import styled from 'styled-components';
import { mediaQuery } from '../../../common/styles/styleUtil';

export const ButtonWrapper = styled.button`
  padding: 12px 24px;
  min-width: 48px;
  border-radius: 3px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  position: relative;

  @media (${mediaQuery.mobile}) {
    padding: 10px 22px;
  }

  &:focus {
    outline-color: #333f48;
  }

  &.fullWidth {
    width: 100%;
  }

  &.fill {
    color: #ffffff;
    background: #0081c6;
    border: 1px solid #0081c6;

    &:hover {
      border: 1px solid #1f6ca0;
      background: #1f6ca0;
    }

    &.disabled {
      color: #a5adb5;
      background: #e9ebed;
    }
  }

  &.ghost {
    color: #333f48;
    border: 1px solid #333f48;
    background: white;

    &:hover {
      background: #f7f8f9;
    }

    &.disabled {
      color: #a5adb5;
      border: 1px solid #d2d5da;
    }
  }

  &.disabled {
    cursor: default;
    user-select: none;
  }
`;
